module.exports = function(len){
  var list = new Array();
  for (var i = 0; i < len; i++) {
    list.push(null);
  }
  return list;
};



//////////////////
// WEBPACK FOOTER
// ./~/keen-dataviz/lib/dataset/utils/create-null-list.js
// module id = 1833
// module chunks = 0